import { render, staticRenderFns } from "./BaseNumberInput.vue?vue&type=template&id=022852d2&scoped=true"
import script from "./BaseNumberInput.vue?vue&type=script&lang=js"
export * from "./BaseNumberInput.vue?vue&type=script&lang=js"
import style0 from "./BaseNumberInput.vue?vue&type=style&index=0&id=022852d2&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "022852d2",
  null
  
)

export default component.exports